import { render } from "./PackagesView.vue?vue&type=template&id=df6adeee&scoped=true"
import script from "./PackagesView.vue?vue&type=script&lang=js"
export * from "./PackagesView.vue?vue&type=script&lang=js"

import "./PackagesView.vue?vue&type=style&index=0&id=df6adeee&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\Robo-FullStack\\FrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6adeee"]])

export default __exports__